import { CheckboxAnswer, TextAnswer } from './anwer-types';
import { useItem, useReport } from './hooks/use-context';
import { AnswerData, QuestionData } from './types';

export function InitialInfos() {
  const { sections } = useItem();
  const { header } = useReport();

  const questions = sections.flatMap((section) => section.questions);
  const involvedQuestion = questions.find(
    (question) =>
      question.question_id === 'e2e0818a-3eab-4ef8-b424-43f7c09141f8',
  );
  const involvedQuestionText = questions.find(
    (question) =>
      question.question_id === 'eed76014-4438-45a9-bb1f-2821d1abcbb4',
  );

  return (
    <div
      style={{
        marginBottom: '20px',
        color: '#000',
      }}
    >
      <div
        style={{
          backgroundColor: '#E0F4E9',
          padding: '10px',
          borderRadius: '6px',
        }}
      >
        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'Cadastro:',
                answers:
                  involvedQuestion?.answers || involvedQuestionText?.answers
                    ? [
                        {
                          content: involvedQuestion?.answers
                            ? involvedQuestion?.answers
                                ?.map((answer) => answer.collection_item.code)
                                .join(', ')
                            : 'Externo',
                        } as AnswerData,
                      ]
                    : [],
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                name: 'Nome dos envolvidos(as):',
                answers: [
                  {
                    content: involvedQuestion?.answers
                      ? involvedQuestion?.answers
                          ?.map((answer) => answer.collection_item?.name)
                          .join(', ')
                          .concat(involvedQuestionText ? ' - ' : '')
                          .concat(
                            involvedQuestionText?.answers?.[0].content || '',
                          )
                      : involvedQuestionText?.answers?.[0].content,
                  } as AnswerData,
                ],
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    'bd9e9286-0db5-480e-9167-7f0ef6a2cfb4',
                ),
                name: 'Tempo na função:',
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    '2a9c1848-8eee-4a6f-b087-b169a364d129',
                ),
                name: 'Cargo/Área de Atuação:',
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    '49a29427-9d93-4af8-b47a-0603216e8d7f',
                ),
                name: 'Data:',
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    'd12964a1-2fc4-487d-bdd4-4bce810f469d',
                ),
                name: 'Horário:',
              } as QuestionData
            }
          />

          <TextAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    '857f02c8-d002-421c-a4ac-b9db34748b7e',
                ),
                name: 'Local:',
              } as QuestionData
            }
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <CheckboxAnswer
            question={
              {
                ...questions.find(
                  (question) =>
                    question.question_id ===
                    'c8dae897-7b4d-409a-8c3d-85fb04755951',
                ),
                name: 'Classificação da ocorrência:',
              } as QuestionData
            }
            options={[
              'Incidente',
              'Acidente sem Afastamento',
              'Acidente com Afastamento',
              'Acidente de Trajeto',
            ]}
          />
        </div>

        <div style={{ display: 'flex', gap: '4px', marginBottom: '6px' }}>
          <TextAnswer
            question={
              {
                name: 'TST responsável pela análise:',
                answers: [{ content: header.author_full_name } as AnswerData],
              } as QuestionData
            }
          />
        </div>

        <div
          style={{
            backgroundColor: '#FFFFFF',
            minHeight: '200px',
            width: '100%',
            padding: '6px 10px',
            borderRadius: '6px',
          }}
        >
          <div
            style={{ marginBottom: '4px', color: 'GrayText', fontSize: '14px' }}
          >
            Descrição do acidente (conforme o ambulatório):
          </div>
          <div>
            {
              questions.find(
                (question) =>
                  question.question_id ===
                  '5a98c6ca-0b07-488c-b59e-d36979afb4de',
              )?.answers?.[0]?.content
            }
          </div>
        </div>
      </div>
    </div>
  );
}
